import { loggerService }  from "@contorion/core/services/logger.service";
import { Component }  from "@contorion/core/components/component";
import {BundleComponent, GaEcommerceItem} from "../interfaces/ga4-event.interface";

export abstract class Ga4EcommerceComponent extends Component {
    protected eventName: string;

    protected constructor(element: HTMLElement, eventName: string) {
        super(element);

        this.eventName = eventName;
        if (window.tc_vars) {
            this.fire();
        } else {
            loggerService.error(`${this.eventName} failed`);
        }
    }

    protected abstract fire(): void;
}
